import type { FunctionComponent } from "react";
import React from "react";
import { observer } from "mobx-react-lite";
import type DistributorRefundDetailViewModel from "../../../../viewModels/finance/refundApprovals/distributorRefunds/distributorRefundDetailViewModel";
import Section from "../../../common/section";
import type DistributorRefundChargeResponse from "../../../../entities/distributorRefundChargeResponse";
import { formatAmount, formatDate, formatDateTime } from "../../../../utils/localizations";
import { emptyValue } from "utils/emptyValue";

interface DistributorRefundChargesSectionProps {
  vm: DistributorRefundDetailViewModel;
}

const DistributorRefundChargesSection: FunctionComponent<DistributorRefundChargesSectionProps> = props => {
  const { vm } = props;
  let content;

  if (vm.item) {
    const charges = vm.item.charges;

    content = (
      <table className="bg-white mb-0 table table-striped">
        <thead>
          <tr>
            <th>{vm.translateModelAttribute("distributorRefundChargeResponse", "vehicle")}</th>
            <th>{vm.translateModelAttribute("distributorRefundChargeResponse", "validSince")}</th>
            <th>{vm.translateModelAttribute("distributorRefundChargeResponse", "orderIdent")}</th>
            <th>{vm.translateModelAttribute("distributorRefundChargeResponse", "chargeTypeId")}</th>
            <th>{vm.translateModelAttribute("distributorRefundChargeResponse", "price")}</th>
            <th>{vm.translateModelAttribute("distributorRefundChargeResponse", "orderConfirmedAt")}</th>
            <th>{vm.translateModelAttribute("distributorRefundChargeResponse", "salespointId")}</th>
            <th>{vm.translateModelAttribute("distributorRefundChargeResponse", "orderExternalId")}</th>
            <th>{vm.translateModelAttribute("distributorRefundChargeResponse", "orderId")}</th>
          </tr>
        </thead>
        <tbody>
          {charges.map((charge: DistributorRefundChargeResponse) => (
            <tr key={charge.officialRecordId}>
              <td>{`${vm.translateCountry(charge.vehicle.countryId)} - ${charge.vehicle.licensePlate}`}</td>
              <td>{`${formatDate(charge.validSince)} - ${formatDate(charge.validUntil)}`}</td>
              <td>{charge.orderIdent}</td>
              <td>{vm.translateChargeType(charge.priceListItemId)}</td>
              <td>{formatAmount(charge.price)}</td>
              <td>{formatDateTime(charge.orderConfirmedAt)}</td>
              <td>{charge.salespointId}</td>
              <td>{charge.orderExternalId ?? emptyValue}</td>
              <td>{charge.orderId}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  return (
    <Section title={vm.translateAttribute("charges")} context={vm.item} contentTable={true}>
      <div style={{ overflowX: "auto" }}>{content}</div>
    </Section>
  );
};

export default observer(DistributorRefundChargesSection);
